import { useQuery } from "@tanstack/react-query";
import { AIFeatureModels } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const FEATURE_MODELS_QUERY_KEY = ["ai-management", "feature-models"];
export const fetchFeatureModels = () => AIFeatureModels.list();
const useFeatureModels = (disabled = false) => {
  const { data, isLoading } = useQuery({
    queryKey: FEATURE_MODELS_QUERY_KEY,
    queryFn: () => defaultOnError(fetchFeatureModels(), "Loading feature models failed", "Could not load feature models"),
    enabled: !disabled
  });
  return { data: data != null ? data : [], isLoading };
};
export default useFeatureModels;
